import {TransferWithinAStation} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const transfer = {
    id: 'transfer',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'transfer',
            title: 'Transfer',
            type: 'item',
            url: '/transfer',
            icon: TransferWithinAStation,
            breadcrumbs: false
        },
       
    ]
};

export default transfer;
